export default __webpack_public_path__ + "static/media/chani depress.e6be1845.svg";